import { isServer } from './is-server';
/**
 * 前端写入cookie
 * @param key 键
 * @param value {string} 值
 * @param days 过期时间，单位天
 * @param path 路径
 */
export function setCookie(key, value, days, path) {
    if (isServer)
        return;
    var expires = '';
    if (days) {
        var d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=".concat(d.toGMTString());
    }
    document.cookie = "".concat(key, "=").concat(value).concat(expires).concat(path ? "; path=".concat(path) : '');
}
